import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminOverrideBadgeComponent } from '@features/shopping/admin-override/admin-override-badge/admin-override-badge.component';
import { DeviceItemData } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-device-carrier',
  templateUrl: './carrier.component.html',
  imports: [CommonModule, TranslationPipe, AdminOverrideBadgeComponent]
})
export class CarrierComponent {
  @Input() device_items: DeviceItemData[];
  @Input() selected_carrier_id: string | number;
  @Input() is_bp_device: boolean | undefined;
  @Output() selected_carrier = new EventEmitter<DeviceItemData>();

  sortCarrier = (device_items: DeviceItemData[]) =>
    this.is_bp_device
      ? [device_items[0]]
      : device_items.sort((a: DeviceItemData, b: DeviceItemData) =>
          a.carrier.name > b.carrier.name ? 1 : b.carrier.name > a.carrier.name ? -1 : 0
        );

  selectCarrier(item: DeviceItemData): void {
    this.selected_carrier.emit(item);
  }
}
